import React from 'react';
import { DECADES, communityTotals, decadeCounts } from '../../data/community';
interface CollectiveTileProps {
  sparse: boolean;
}

/**
 * What the community adds up to. Aggregate only — never per-person, never a
 * ranking, and never anything that could identify who is counted.
 */
export function CollectiveTile({
  sparse
}: CollectiveTileProps) {
  const totals = communityTotals(sparse);
  const counts = decadeCounts(sparse);
  const peak = Math.max(...DECADES.map(decade => counts[decade]), 1);
  const coverage = Math.round(totals.yearsCovered / totals.yearsTotal * 100);
  const figures = [{
    value: totals.collectiveYears,
    label: 'collective years represented'
  }, {
    value: `${totals.yearsCovered} of ${totals.yearsTotal}`,
    label: 'years with something in them'
  }, {
    value: totals.memoriesShared,
    label: 'memories shared'
  }, {
    value: totals.archiveItems,
    label: 'items in the archive'
  }];
  return <section aria-labelledby="collective-tile" className="flex flex-col gap-5 rounded-card border border-rule bg-card p-5" data-id="element-112" data-mp="2x4alk0ct8kyp">
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1" data-id="element-113" data-mp="383cmgc6inbjc">
        <h2 id="collective-tile" className="text-heading font-semibold text-ink" data-id="element-114" data-mp="381i0qvnf7fe7">
          What we add up to
        </h2>
        <p className="text-small text-ink-muted" data-id="element-115" data-mp="2z2wnng0pwskt">{coverage}% of the fifty years covered</p>
      </div>

      <dl className="grid grid-cols-2 gap-x-4 gap-y-5 lg:grid-cols-4" data-id="element-116" data-mp="3vsnixhgu2jro">
        {figures.map(figure => <div key={figure.label} className="flex flex-col gap-0.5" data-id="element-117" data-mp="3rqscxznyji7k">
            <dt className="sr-only" data-id="element-118" data-mp="3rph95zuiiagg">{figure.label}</dt>
            <dd className="text-page-title font-semibold text-ink" data-id="element-119" data-mp="3mqxo01nqt2p5">{figure.value}</dd>
            <span aria-hidden="true" className="text-small text-ink-muted" data-id="element-120" data-mp="3hs2x0cfmg7ty">
              {figure.label}
            </span>
          </div>)}
      </dl>

      <div className="flex flex-col gap-2" data-id="element-121" data-mp="26dz3f7cy4lpf">
        <span className="text-eyebrow-caption font-semibold uppercase text-ink-muted" data-id="element-122" data-mp="26cxvhbr88fbx">
          Members by decade
        </span>
        <ol className="flex items-end gap-2" data-id="element-123" data-mp="27t1tm5naav4y">
          {DECADES.map(decade => {
          const count = counts[decade];
          return <li key={decade} className="flex min-w-0 flex-1 flex-col items-center gap-1.5" data-id="element-124" data-mp="1yv9cqx1wzffg">
                <span className="text-small text-ink-muted" data-id="element-125" data-mp="23t1dmgkjebvs">{count}</span>
                <span aria-hidden="true" style={{
              height: `${Math.max(count / peak * 64, 4)}px`
            }} className={`w-full rounded-control ${count > 0 ? 'bg-primary' : 'bg-canvas'}`} data-id="element-126" data-mp="1p4n2zjgvpj4o" />
                <span className="truncate text-eyebrow-caption text-ink-muted" data-id="element-127" data-mp="1g25hj791suiq">{decade}</span>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}